// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e39fb35b","403":"e5aa1e4f","455":"ba0306d1","484":"14cb0921","869":"b6dda42b","974":"87dcfbc9","977":"240addac"}[chunkId] + ".chunk.js";
};